import { FC } from 'react';

export const Protected: FC = () => {
  return <h1>This component is protected</h1>;
};
